module.exports = __webpack_public_path__ + "img/8.d7351c1c.png";